module.exports = __webpack_public_path__ + "static/media/saveEdit.8701f2ac.png";